import React, {Component} from 'react';

import strings from 'strings';
import {
	no_numbers,
	nn_numbers,
	no_numbers_more_items,
	nn_numbers_more_items,
} from './assets';
import listen from 'assets/listen.png';
import {getWorkingMemory, getOlderVersionWorkingMemory} from 'constants/tests';

import './styles.scss';
import {TYPES} from '../../constants/index';
import {stopAllSounds, playSound} from 'utils/playSound';

class Test extends Component {
	constructor(props) {
		super(props);
		const {ageGroup, testKeyType} = this.props;
		const isNormingTest =
			ageGroup >= 2 ||
			testKeyType === TYPES.ADULT_FOLLOWUP ||
			testKeyType === TYPES.YOUTH_FOLLOWUP;
		const selectedVersion = isNormingTest
			? getWorkingMemory
			: getOlderVersionWorkingMemory;
		this.answerLengths = selectedVersion()
			.getNumberSteps()
			.map((row) => row.length);

		switch (strings.getLanguage()) {
			case 'nn':
				this.assets = nn_numbers;
				this.moreItemsAudio = nn_numbers_more_items;
				break;
			case 'no':
			default:
				this.assets = no_numbers;
				this.moreItemsAudio = no_numbers_more_items;
				break;
		}
	}

	componentWillReceiveProps(newProps) {
		if (newProps.currentStep !== this.props.currentStep) {
			this.startNewTask(newProps.currentStep);
		}
	}

	componentDidMount() {
		if (this.button) this.button.click();
		this.initializeAudio();
	}
	componentWillUnmount() {
		this.stopSounds();
		clearTimeout(this.timeout);
	}

	initializeAudio = () => {
		this.timeout = setTimeout(
			() => this.startNewTask(this.props.currentStep),
			1000
		);
	};

	startNewTask = (taskNumber) => {
		this.stopSounds();
		this.playNumbers(taskNumber);
	};

	playNumbers = (sound) => {
		const src = this.assets[sound];
		if (!src) return;

		if (this.shouldPlayMoreItemsAudio(sound)) {
			playSound(this.moreItemsAudio, {
				onend: () => {
					playSound(src);
				},
			});
			return;
		}

		playSound(src);
	};

	shouldPlayMoreItemsAudio = (taskNumber) => {
		if (taskNumber <= 0) return false;

		return (
			this.answerLengths[taskNumber] >
			this.answerLengths[taskNumber - 1]
		);
	};

	stopSounds = () => {
		stopAllSounds();
	};

	render() {
		const {testKeyType, ageGroup} = this.props;
		const isNormingTest =
			ageGroup >= 2 ||
			testKeyType === TYPES.ADULT_FOLLOWUP ||
			testKeyType === TYPES.YOUTH_FOLLOWUP;
		return (
			<div className="WorkingMemory">
				<img className="listen-image" src={listen} alt="" />
				{!isNormingTest && <p>{strings.wsn_test1}</p>}
			</div>
		);
	}
}

export default Test;
